import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  addLicenseSaga,
  editLicenseSaga,
  deleteLicenseSaga,
  getLicensesSaga
} from "./saga";

export default function* watchLicense() {
  yield takeLatest(actionTypes.ADD_LICENSE, addLicenseSaga);
  yield takeLatest(actionTypes.EDIT_LICENSE, editLicenseSaga);
  yield takeLatest(actionTypes.DELETE_LICENSE, deleteLicenseSaga);
  yield takeLatest(actionTypes.GET_LICENSES, getLicensesSaga);
}